import { SvgIcon, SvgIconProps, useTheme } from '@mui/material';
import { RADAR_PATH } from 'features/mapping/components/controls/TimelineModeControl/RadarIcon';

const BADGE_PATH =
  'M18 11.5C21.5899 11.5 24.5 14.4101 24.5 18C24.5 21.5899 21.5899 24.5 18 24.5C14.4101 24.5 11.5 21.5899 11.5 18C11.5 14.4101 14.4101 11.5 18 11.5Z';
const PLAY_TRIANGLE_PATH =
  'M16.6621 15.625V20.625L20.6621 18.125L16.6621 15.625Z';

export const TimelinePlayIcon = (props: SvgIconProps): JSX.Element => {
  const theme = useTheme();
  const cutoutColor = theme.palette.button.neutral.dark;

  return (
    <SvgIcon {...props} viewBox="0 0 25 25">
      <path d={RADAR_PATH} fill={theme.palette.text.disabled} />
      <path d={BADGE_PATH} fill={cutoutColor} />
      <circle cx="18" cy="18" r="5" fill={theme.palette.text.primary} />
      <path d={PLAY_TRIANGLE_PATH} fill={cutoutColor} />
    </SvgIcon>
  );
};
